export default __webpack_public_path__ + "static/media/packageConsolidation.85984a7e.svg";